export const SALE_STATUS = 'sale';
export const CONFIRMED_TERMS_AND_CONDITIONS = 'CONFIRMED_TERMS_AND_CONDITIONS';
